module.exports = __webpack_public_path__ + "components/incentive/static/nine-day-ab288178e8d820fbded907ecc3c1a37f.svg";